import { fetchAndCacheWithoutPage } from '@/components/shared/CacheStroage/CacheWithoutPage';

import { IResponse } from '@/utils/interfaces';
import { IShowcaseShortVideo } from '@/utils/interfaces/ShowcaseShortVideo';

import { baseForPdf } from '../apiClients';
import { Endpoints } from '../../network';

export const getAllShowcaseShortVideo = async (): Promise<
  IResponse<IShowcaseShortVideo[]>
> => {
  const apiUrl = `${Endpoints.getAllShowcaseShortVideo}`;

  const apiCall = async () => {
    const response = await baseForPdf.get(apiUrl);
    return response?.data;
  };

  return fetchAndCacheWithoutPage(apiCall, apiUrl);
};
